import React from 'react'
import { connect } from 'react-redux'
import { withRouterProps } from '../../utils/with-router-props'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'

import { routes, buildRoutePath, apiResourceEndpoint } from '../../../constants/routes'
import { fetchApiDataIfNeeded, callApi } from '../../../actions/api'

import slugify from 'slugify'

class CreateSite extends React.Component {
    state = {
        isManual: false,
        slug: ''
    }

    componentDidMount = () => {
        this.props.dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('config-value', 'LIST'), {
            filter: ['field|drupal_version', 'field|php_version', 'field|webserver_version', 'field|database_version', 'field|site_size'],
            filterMethod: 'OR'
        }))
        this.props.dispatch(fetchApiDataIfNeeded(apiResourceEndpoint('site', 'LIST')))
    }

    submitFX = (formData, formId) => {
        this.props.dispatch(callApi(apiResourceEndpoint('site', 'CREATE'), formData, formId))
    }

    successFX = (siteId) => {
        let nextRoute = buildRoutePath(routes.sitesView, { siteId })
        this.props.navigate(nextRoute)
    }

    handleNameChange = (key, value) => {
        if (!this.state.isManual) {
            this.setState({ slug: slugify(value, {
                replacement: '-',
                lower: true
            }) })
        }
    }

    handleSlugChange = (key, value) => {
        this.setState({
            isManual: true,
            [key]: slugify(value, {
                replacement: '-',
                lower: true
            })
        })
    }

    render = () => {
        const drupalOptions = this.props.drupalVersions.map(opt => {
            return { value: opt.get('id'), label: opt.get('display') }
        })
        const phpOptions = this.props.phpVersions.map(opt => {
            return { value: opt.get('id'), label: opt.get('display') }
        })
        const webserverOptions = this.props.webserverVersions.map(opt => {
            return { value: opt.get('id'), label: opt.get('display') }
        })
        const databaseOptions = this.props.databaseVersions.map(opt => {
            return { value: opt.get('id'), label: opt.get('display') }
        })
        const sizeOptions = this.props.siteSizes.map(opt => {
            return { value: opt.get('id'), label: opt.get('display') }
        })

        return (
            <div className="box mt-4">
                <h1>Create a New Site</h1>
                <p>Use the form below to configure the defaults for your site.</p>
                <SHSForm submitFX={this.submitFX} successFX={this.successFX}>
                    <InputElement
                        id="name"
                        type="text"
                        label="Site Name"
                        placeholder="e.g., My Site"
                        onChange={this.handleNameChange}
                        required />
                    <InputElement
                        id="slug"
                        type="text"
                        label="Domain"
                        default={this.state.slug}
                        onChange={this.handleSlugChange}
                        placeholder="e.g., my-site"
                        helperText="This value is auto-generated based on your site name, but can be overridden if needed."
                        required />
                    <InputElement
                        type="valueSelect"
                        id="siteSize"
                        label="Site Size"
                        options={sizeOptions}
                        required />
                    <InputElement
                        type="valueSelect"
                        id="drupalVersion"
                        label="Drupal Version"
                        options={drupalOptions}
                        required />
                    <InputElement
                        type="valueSelect"
                        id="phpVersion"
                        label="PHP Version"
                        options={phpOptions}
                        required />
                    <InputElement
                        type="valueSelect"
                        id="webserverVersion"
                        label="Web Server Version"
                        options={webserverOptions}
                        required />
                    <InputElement
                        type="valueSelect"
                        id="databaseVersion"
                        label="Database Version"
                        options={databaseOptions}
                        required />
                </SHSForm>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        drupalVersions: state.get('configValues')
            .filter(cv => cv.get('field') === 'drupal_version')
            .sort((a, b) => {
                if (a.get('order') > b.get('order')) {
                    return 1
                }
                return -1
            }),
        phpVersions: state.get('configValues')
            .filter(cv => cv.get('field') === 'php_version')
            .sort((a, b) => {
                if (a.get('order') > b.get('order')) {
                    return 1
                }
                return -1
            }),
        webserverVersions: state.get('configValues')
            .filter(cv => cv.get('field') === 'webserver_version')
            .sort((a, b) => {
                if (a.get('order') > b.get('order')) {
                    return 1
                }
                return -1
            }),
        databaseVersions: state.get('configValues')
            .filter(cv => cv.get('field') === 'database_version')
            .sort((a, b) => {
                if (a.get('order') > b.get('order')) {
                    return 1
                }
                return -1
            }),
        siteSizes: state.get('configValues')
            .filter(cv => cv.get('field') === 'site_size')
            .sort((a, b) => {
                if (a.get('order') > b.get('order')) {
                    return 1
                }
                return -1
            })
    }
}

export default withRouterProps(connect(mapStateToProps)(CreateSite))
